import { FC, ReactNode } from 'react';
import { ProCheckbox } from '../antd';
import SearchFormItem from './subpage/searchFormItem';
import SearchFormDisabled from './subpage/disabled';
import {
  BaseSearchFormItemProps,
  SearchFormItemEnum,
} from './interface/baseInterface';
import { CheckboxProps } from 'antd/lib/checkbox';

export interface BaseCheckboxProps extends CheckboxProps {
  /** 多选按钮文字 */
  checkboxText?: ReactNode;
  /** 禁用时选中文字 */
  checkedChildren?: ReactNode;
  /** 禁用时未选中文字 */
  unCheckedChildren?: ReactNode;
}
export interface SearchFormCheckboxProps extends BaseSearchFormItemProps {
  checkboxProps?: BaseCheckboxProps;
}
/** 选中框 */
export const SearchFormCheckbox: FC<SearchFormCheckboxProps> = props => {
  const {
    checkboxProps = {},
    isDetail,
    name,
    form,
    isTable,
    testId,
    label,
    hideLabel,
    render,
    disabledRender,
    ...resProps
  } = props;
  const { checkboxText, checkedChildren, unCheckedChildren, ...restCheckboxProps } = checkboxProps;
  const handleRender = (val: any) => {
    return val
      ? checkedChildren || '是'
      : unCheckedChildren || '否';
  };
  return (
    <SearchFormItem
      {...resProps}
      label={!hideLabel && label}
      name={name}
      valuePropName="checked"
      test-id={`${testId}-${name}`}
    >
      {isDetail || (checkboxProps && checkboxProps.disabled) ? (
        <SearchFormDisabled
          form={form}
          name={name}
          render={render || disabledRender || handleRender}
          isTable={isTable}
        />
      ) : (
        <ProCheckbox {...restCheckboxProps}>
          {checkboxText}
        </ProCheckbox>
      )}
    </SearchFormItem>
  );
};
SearchFormCheckbox.displayName = SearchFormItemEnum.SearchFormCheckbox;

export default SearchFormCheckbox;
